import FormAutomation from 'components/form-automation'
import { ExportType_s, RdcfExport_s } from 'components/import-export/import-export-styles'
import ListboxInput from "components/inputs/listbox"
// Components
import ConfirmationModal from "components/modal/confirmation-modal"
// Data
import exportService from "data/export"
import { local } from 'data/lib/local-json'
import loadingService from "data/loading"
import propertyService from "data/property"
import _ from 'lodash'
import React, { useEffect, useState } from "react"
// Styles
import { Button_s } from 'styles/app-styles'

type ListboxOption = {
  label: string,
  value: string|number
}

const RdcfExport = () => {
  const [exportOption, setExportOption] = useState<string>('data')
  const [exportType, setExportType] = useState<string|null>(null)
  const [showErrorModal, toggleErrorModal] = useState<boolean>(false);
  const [propsWithErrors, updatePropsWithErrors] = useState<object[]|null>(null);
  const [properties, setProperties] = useState<object[]|null>(null)
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const isFolder = window.location.pathname.includes("/folder");

  let allDownloadTemplates = [
    { value: 'ImportTemplate_Area', label: 'Area Measures'},
    { value: 'ImportTemplate_Inflation', label: 'Inflation'},
    { value: 'ImportTemplate_LineItem', label: 'Line Items'},
    { value: 'ImportTemplate_Property', label: 'Property Settings'}
  ]
  let exportDataTemplates = [
    { value: 'area', label: 'Area Measures'},
    { value: 'inflation', label: 'Inflation'},
    { value: 'lineitem', label: 'Line Items'},
    { value: 'property', label: 'Property Settings'}
  ]
  const [allTemplates, setAllTemplates] = useState<ListboxOption[]>(allDownloadTemplates)
  const [exportTemplates, setExportTemplates] = useState<ListboxOption[]>(exportDataTemplates)

  let commercialDownloadTemplates = [
    { value: 'ImportTemplate_Downtime', label: 'Downtime'},
    { value: 'ImportTemplate_FreeRent', label: 'Free Rent'},
    { value: 'ImportTemplate_Increase', label: 'Increase'},
    { value: 'ImportTemplate_MarketLease', label: 'Market Lease'},
    { value: 'ImportTemplate_Payout', label: 'Payout'},
    { value: 'ImportTemplate_RenewalProbability', label: 'Renewal Probability'},
    { value: 'ImportTemplate_Rent', label: 'Rent'},
    { value: 'ImportTemplate_RentRoll', label: 'Rent Roll'},
    { value: 'ImportTemplate_TenantCapital', label: 'Tenant Capital'}
  ]
  const commercialDataTemplates = [
    { value: 'downtime', label: 'Downtime'},
    { value: 'freerent', label: 'Free Rent'},
    { value: 'increase', label: 'Increase'},
    { value: 'lc', label: 'Leasing Commission'},
    { value: 'marketlease', label: 'Market Lease'},
    { value: 'othercapital', label: 'Other Capital'},
    { value: 'payout', label: 'Payout'},
    { value: 'renewalprobability', label: 'Renewal Probability'},
    { value: 'rent', label: 'Rent'},
    { value: 'rentroll', label: 'Rent Roll'},
    { value: 'tenantcapital', label: 'Tenant Capital'},
    { value: 'ti', label: 'Tenant Improvement'}
  ]

  function getTemplates(propertyType:string) {
    if (propertyType === 'Hospitality' || propertyType === 'Mixed-Use' || isFolder){
      allDownloadTemplates.push({ value: 'ImportTemplate_Multifamily', label: 'Multifamily Rent Roll'})
      exportDataTemplates.push({ value: 'multifamily', label: 'Multifamily Rent Roll'})
    }
    if (propertyType === 'Commercial' || propertyType === 'Mixed-Use' || isFolder) {
      allDownloadTemplates.push(...commercialDownloadTemplates);
      allDownloadTemplates.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      })
    }
    if (propertyType === 'Commercial' || propertyType === 'Mixed-Use' || isFolder){
      exportDataTemplates.push(...commercialDataTemplates);
      exportDataTemplates.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      })
    }
    if (propertyType === 'Hospitality' || isFolder){
      allDownloadTemplates.push({ value: 'ImportTemplate_Room', label: 'Rooms'})
      exportDataTemplates.push({ value: 'room', label: 'Rooms'})
    }
    setAllTemplates(allDownloadTemplates)
    setExportTemplates(exportDataTemplates)
  }

  useEffect(() => {

    exportService.stream().subscribe(obj => {
      if (obj['propsWithErrors']) updatePropsWithErrors(obj['propsWithErrors']);
      toggleErrorModal(obj['exportConfirmVisible']);
      loadingService.toggleLoading(obj['loading'], 'export-icon');
    });

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        const currentProperty = _.find(data.value, {propertyid: data.current});
        if(currentProperty) setPropertyId(currentProperty['propertyid'])
      }
    });

    (async () => {
      await propertyService.fetchByFolderId(_.last(local('folderPath')), false)
      setProperties(propertyService.value())
    })()

    return function cleanup() {
      propertySubscription.unsubscribe()
    }

  }, []);

  useEffect(() => {
    if (isFolder) getTemplates('Commercial')
    if (_.isNil(propertyId)) return
    if (!isFolder) getTemplates(local('property_type'))

  }, [propertyId])

  function confirmAndClose():void {
    exportService.exportFileCb(exportType || defaultExportType as string, null);
    if (showErrorModal) toggleErrorModal(false);
  }

  const defaultExportType = exportOption === 'data' ? exportTemplates?.[0]['value'] : allTemplates?.[0]['value']

  return (
    <RdcfExport_s id="rdcfEexport">
      <div>
        <div>
          <label>
            <input
              type="radio"
              onClick={() => setExportOption('data')}
              checked={exportOption === 'data'}/>
            Data
          </label>
          <label>
            <input
              type="radio"
              onClick={() => setExportOption('empty')}
              checked={exportOption === 'empty'}/>
            Empty Template
          </label>
        </div>
        <div>
          <Button_s className="automated" onClick={exportOption === 'empty' ? ()=>exportService.downloadTemplate(exportType || defaultExportType) : ()=>exportService.exportFile(exportType || defaultExportType as string, properties, null)}>Export</Button_s>
        </div>
      </div>
      <ExportType_s>
        <label>Export Type</label>
        <ListboxInput
          className="automated"
          field="exportType"
          value={exportType || defaultExportType}
          multiple={false}
          persist={(field:string, val:string) => setExportType(val)}
          options={exportOption === 'data' ? exportTemplates : allTemplates}
        />
      </ExportType_s>
      <ConfirmationModal
        show={showErrorModal}
        toggleShow={toggleErrorModal}
        title={'Export Validation Warning'}
        confirmText={'Ignore'}
        confirmFunc={()=>confirmAndClose()}
        cancelFunc={()=>exportService.cancelExport()}
        message={`Be advised that if you choose to export before fixing all the input errors for the properties in this folder your exported file could be missing data.  Do you wish to ignore this warning and export anyway?`}
        confirmOnly={false}
        closeOnly={false}
      >
        { propsWithErrors && <div>
          <p>The following properties in this folder have input errors:</p>
          <ul>{ propsWithErrors.map(prop=> <li key={`error-${prop['code']}`}>{prop['code']}</li>) }</ul>
        </div> }
      </ConfirmationModal>
      <FormAutomation automationContainerId="rdcfEexport" initialFocusIndex={1} />
    </RdcfExport_s>
  )
}

export default RdcfExport